import { c as _c } from "react/compiler-runtime";
import { Box } from "@mui-wrapper";
import { Chip, ChipTag } from "@flat-ui";
import { sortMarkupTags } from "@pages/project-details/project-markups/markup-tags-sort";
/** Renders a tag of a markup as the flat-ui tag chip, with its color as a dot */
export function MarkupTagChip(t0) {
  const $ = _c(13);
  const {
    tag,
    maxWidth: t1
  } = t0;
  const maxWidth = t1 === undefined ? "100%" : t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      minWidth: 0,
      maxWidth: "100%"
    };
    $[0] = t2;
  } else {
    t2 = $[0];
  }
  let t3;
  if ($[1] !== maxWidth) {
    t3 = {
      display: "flex",
      minWidth: 0,
      maxWidth,
      "& > *": t2
    };
    $[1] = maxWidth;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  let t5;
  if ($[3] !== tag.name) {
    t4 = <var>{tag.name}</var>;
    t5 = <var>{tag.name}</var>;
    $[3] = tag.name;
    $[4] = t4;
    $[5] = t5;
  } else {
    t4 = $[4];
    t5 = $[5];
  }
  const t6 = tag.color ?? undefined;
  let t7;
  if ($[6] !== t4 || $[7] !== t5 || $[8] !== t6) {
    t7 = <ChipTag label={t4} tooltip={t5} color={t6} size="small" />;
    $[6] = t4;
    $[7] = t5;
    $[8] = t6;
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  let t8;
  if ($[10] !== t3 || $[11] !== t7) {
    t8 = <Box sx={t3}>{t7}</Box>;
    $[10] = t3;
    $[11] = t7;
    $[12] = t8;
  } else {
    t8 = $[12];
  }
  return t8;
}
/** Renders the amount of tags not shown as chips, with their names on hover, like the tag chips */
export function MarkupMoreTagsChip(t0) {
  const $ = _c(11);
  const {
    tags,
    sx
  } = t0;
  const t1 = `+${tags.length}`;
  let t2;
  if ($[0] !== t1) {
    t2 = <var>{t1}</var>;
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      display: "flex",
      flexDirection: "column"
    };
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] !== tags) {
    t4 = tags.map(_temp);
    $[3] = tags;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] !== t4) {
    t5 = <Box component="div" sx={t3}>{t4}</Box>;
    $[5] = t4;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] !== sx || $[8] !== t2 || $[9] !== t5) {
    t6 = <Chip sx={sx} label={t2} size="small" variant="filled" color="default" tooltip={t5} />;
    $[7] = sx;
    $[8] = t2;
    $[9] = t5;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  return t6;
}

/**
 * MarkupsTags Component
 *
 * This component displays tags associated with a markup. If no tags are present, it displays a tag icon.
 * If there are tags, it shows the first tag as a chip and, if more tags are available, it shows an additional
 * chip with a count of the remaining tags.
 *
 * @param {BaseMarkupProps} param0 - The props containing markup data.
 * @returns {JSX.Element} - A component that displays tags or a user icon.
 */
function _temp(tag) {
  return <var key={tag.id}>{tag.name}</var>;
}
export function MarkupTags(t0) {
  const $ = _c(3);
  const {
    markup
  } = t0;
  let t1;
  if ($[0] !== markup.labels) {
    const sortedTags = sortMarkupTags(markup.labels);
    let t2;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
      t2 = {
        pl: "10px"
      };
      $[2] = t2;
    } else {
      t2 = $[2];
    }
    t1 = <Box component="div" sx={t2}>{sortedTags.length === 0 ? "-" : <Box sx={{
        display: "flex"
      }}><MarkupTagChip tag={sortedTags[0]} maxWidth="6.25rem" />{sortedTags.length > 1 && <MarkupMoreTagsChip tags={sortedTags.slice(1)} sx={{
          ml: "10px"
        }} />}</Box>}</Box>;
    $[0] = markup.labels;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
}